var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.lang,attrs:{"id":"app"}},[_c('Navbar',{attrs:{"showLogo":_vm.showLogo}}),_c('router-view',{attrs:{"showLogo":_vm.showLogo,"scrollY":_vm.scrollY}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }